/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import Utils from "Utils/utils";
import { REPORT_DATE_FILTER_MIN_DATE } from "Static/constant";
import UpgradeIconTooltip from "Components/Paywall/UpgradeIconTooltip";
import userDetail from "Stores/userDetail";
import PaywallUtils from "Utils/PaywallUtils";

const DateRangePicker = props => {
  const {
    className = "",
    filterCbk = () => {},
    cancelCbk = () => {},
    customDate,
    inFreePlan = false,
    pageType = "",
    upgradePopupName = "",
    handleCustomDate = () => {},
    customDateObj = "",
    enableTimeRange = false
  } = props || {};

  const { planName = "" } = userDetail?.userFeatureFlag || {};

  const convertDateTo24TimeString = date => {
    if (!date) return "00:00:00";
    const dateObj = new Date(date);
    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const seconds = dateObj.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  const getInitialStartTime = () => {
    if (customDateObj?.startDate) {
      return convertDateTo24TimeString(customDateObj.startDate);
    }
    return "00:00:00";
  };

  const getInitialEndTime = () => {
    if (customDateObj?.endDate) {
      return convertDateTo24TimeString(customDateObj.endDate);
    }
    return "23:59:59";
  };

  const [startTime, setStartTime] = useState(getInitialStartTime());
  const [endTime, setEndTime] = useState(getInitialEndTime());

  const prevStartDateRef = useRef(null);
  const prevEndDateRef = useRef(null);

  const getDatePartOnly = date => {
    if (!date) return null;
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  };

  const highlightErrMsg = (id, value) => {
    const errDom = document.getElementById(id);
    let toggleClass = errDom && errDom.classList;
    value
      ? toggleClass.add("highlightErr")
      : toggleClass.remove("highlightErr");
  };

  const handleChange = (item = {}) => {
    const { startDate = false, endDate = false } = item?.selection || {};

    // Preserve existing endDate if only startDate is being changed
    // Preserve existing startDate if only endDate is being changed
    const currentSelection = customDate?.[0] || {};
    const newSelection = {
      ...item.selection,
      startDate: startDate || currentSelection.startDate,
      endDate: endDate || currentSelection.endDate
    };

    let exceedRange =
      Utils.getDateDiffNumber(newSelection.startDate, newSelection.endDate) >
        91 || "";
    let applyBtn = document.getElementById("applyCustomDateFilter");
    highlightErrMsg("customDateFilterErrMsg", exceedRange);
    applyBtn &&
      newSelection.endDate &&
      newSelection.startDate &&
      (applyBtn.disabled = exceedRange || false);
    handleCustomDate([newSelection]);
  };

  const combineDateAndTime = (date, timeString) => {
    if (!date || !timeString) {
      return date;
    }
    const [hours24, minutes, seconds = 0] = timeString.split(":").map(Number);
    const newDate = new Date(date);
    newDate.setHours(hours24 || 0, minutes || 0, seconds || 0, 0);
    return newDate;
  };

  const formatTimeString = timeString => {
    if (!timeString) return "00:00:00";
    const parts = timeString.split(":");
    const hours = parts[0]?.padStart(2, "0") || "00";
    const minutes = parts[1]?.padStart(2, "0") || "00";
    const seconds = parts[2]?.padStart(2, "0") || "00";
    return `${hours}:${minutes}:${seconds}`;
  };

  const createApplyButton = () => {
    const dom = document.querySelector(`.dateRangePicker`);
    if (!dom) return;
    const existingButtonSection = dom.querySelector(".dateBtnSection");
    if (existingButtonSection) {
      existingButtonSection.remove();
    }

    const parentDom = document.createElement("div");
    parentDom.setAttribute("class", "dateBtnSection");
    const cancelBtn = document.createElement("input");
    cancelBtn.setAttribute("type", "button");
    cancelBtn.setAttribute("value", "Cancel");
    cancelBtn.setAttribute("class", "cancelCustomDateFilter");
    cancelBtn.setAttribute("id", "cancelCustomDateFilter");
    cancelBtn.addEventListener("click", e => {
      cancelCbk();
    });
    parentDom.appendChild(cancelBtn);
    const applyBtn = document.createElement("input");
    applyBtn.setAttribute("type", "button");
    applyBtn.setAttribute("value", "Apply");
    applyBtn.setAttribute("class", "applyCustomDateFilter");
    applyBtn.setAttribute("id", "applyCustomDateFilter");
    // Use current customDate state to check if dates are selected
    const currentSelection = customDate?.[0] || customDateObj || {};
    const { startDate = false, endDate = false } = currentSelection;
    (!startDate || !endDate) && applyBtn.setAttribute("disabled", true);
    applyBtn.addEventListener("click", e => {
      const startHoursInput = document.getElementById("startTimeHours");
      const endHoursInput = document.getElementById("endTimeHours");
      const isTimeRangeEnabled = !!(startHoursInput && endHoursInput);

      if (!inFreePlan) {
        // Use current customDate state instead of customDateObj prop to get latest selection
        const currentSelection = customDate?.[0] || customDateObj || {};
        const { startDate: currentStartDate, endDate: currentEndDate } =
          currentSelection;

        if (currentStartDate && currentEndDate) {
          if (isTimeRangeEnabled || enableTimeRange) {
            const startTime24Value = getCustomTimeValue("start");
            const endTime24Value = getCustomTimeValue("end");
            const startDateTime = combineDateAndTime(
              new Date(currentStartDate),
              startTime24Value
            );
            const endDateTime = combineDateAndTime(
              new Date(currentEndDate),
              endTime24Value
            );
            filterCbk({
              startDate: startDateTime,
              endDate: endDateTime,
              startTime: startTime24Value,
              endTime: endTime24Value
            });
          } else {
            filterCbk();
          }
        } else {
          filterCbk();
        }
      } else {
        PaywallUtils.upgradeUtilsFunction(
          upgradePopupName,
          true,
          planName,
          inFreePlan
        );
        cancelCbk();
      }
    });
    parentDom.appendChild(applyBtn);
    const errDom = document.createElement("div");
    errDom.setAttribute("id", "customDateFilterErrMsg");
    errDom.innerText = "*Date range limited to 90 days";
    parentDom.appendChild(errDom);
    if (inFreePlan) {
      var upgradeIcon = document.createElement("span");
      upgradeIcon.setAttribute("class", "wrapUpgradeIconTooltip");
      upgradeIcon.setAttribute("id", "wrapUpgradeIconTooltip");
      ReactDOM.render(
        <UpgradeIconTooltip type={upgradePopupName} enableTooltip={false} />,
        upgradeIcon
      );
      parentDom.appendChild(upgradeIcon);
    }
    dom.appendChild(parentDom);
  };

  const convert24To12 = hour24 => {
    if (hour24 === 0) return { hour12: 12, ampm: "AM" };
    if (hour24 < 12) return { hour12: hour24, ampm: "AM" };
    if (hour24 === 12) return { hour12: 12, ampm: "PM" };
    return { hour12: hour24 - 12, ampm: "PM" };
  };

  const convert12To24 = (hour12, ampm) => {
    if (ampm === "AM") {
      return hour12 === 12 ? 0 : hour12;
    } else {
      return hour12 === 12 ? 12 : hour12 + 12;
    }
  };

  const parseTimeString = timeString => {
    if (!timeString) return { hours: 12, minutes: 0, seconds: 0, ampm: "AM" };
    const parts = timeString.split(":");
    const hour24 = parseInt(parts[0] || 0, 10);
    const { hour12, ampm } = convert24To12(hour24);
    return {
      hours: hour12,
      minutes: parseInt(parts[1] || 0, 10),
      seconds: parseInt(parts[2] || 0, 10),
      ampm: ampm
    };
  };

  const buildTimeString = (hour12, minutes, seconds, ampm) => {
    const hour24 = convert12To24(hour12, ampm);
    const h = hour24.toString().padStart(2, "0");
    const m = Math.max(0, Math.min(59, minutes || 0))
      .toString()
      .padStart(2, "0");
    const s = Math.max(0, Math.min(59, seconds || 0))
      .toString()
      .padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const getCustomTimeValue = prefix => {
    const hoursInput = document.getElementById(`${prefix}TimeHours`);
    const minutesInput = document.getElementById(`${prefix}TimeMinutes`);
    const secondsInput = document.getElementById(`${prefix}TimeSeconds`);
    const ampmInput = document.getElementById(`${prefix}TimeAmPm`);
    if (hoursInput && minutesInput && secondsInput && ampmInput) {
      return buildTimeString(
        parseInt(hoursInput.value || 12, 10),
        parseInt(minutesInput.value || 0, 10),
        parseInt(secondsInput.value || 0, 10),
        ampmInput.textContent || "AM"
      );
    }
    return prefix === "start" ? startTime : endTime;
  };

  const createTimeInputField = (id, value, min, max, onChange) => {
    const input = document.createElement("input");
    input.setAttribute("type", "number");
    input.setAttribute("id", id);
    input.setAttribute("min", min);
    input.setAttribute("max", max);
    input.setAttribute("value", value);
    input.style.cssText = `
      width: 28px;
      padding: 6px 2px;
      border: none;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
      text-align: center;
      background: transparent;
      font-family: Graphik-Regular;
      -moz-appearance: textfield;
    `;

    input.addEventListener("wheel", e => e.preventDefault());
    input.addEventListener("keydown", e => {
      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
        e.preventDefault();
        const current = parseInt(e.target.value || 0, 10);
        const newValue =
          e.key === "ArrowUp"
            ? Math.min(max, current + 1)
            : Math.max(min, current - 1);
        e.target.value = newValue.toString().padStart(2, "0");
        onChange();
      }
    });
    input.addEventListener("input", e => {
      let inputValue = e.target.value;

      // Allow empty input while user is typing
      if (
        inputValue === "" ||
        inputValue === null ||
        inputValue === undefined
      ) {
        return;
      }

      let val = parseInt(inputValue, 10);

      // If not a valid number, allow it temporarily (user might be typing)
      if (isNaN(val)) {
        return;
      }

      // Only intervene if the value clearly exceeds max and is longer than 2 digits
      // This handles cases like "125" when max is 12 (user typed "5" when "12" was selected)
      if (val > max && inputValue.length > 2) {
        // Try to extract a valid number from the input
        const lastTwo = parseInt(inputValue.slice(-2), 10);
        const lastOne = parseInt(inputValue.slice(-1), 10);
        const firstTwo = parseInt(inputValue.slice(0, 2), 10);
        const firstOne = parseInt(inputValue.slice(0, 1), 10);

        if (!isNaN(lastTwo) && lastTwo >= min && lastTwo <= max) {
          val = lastTwo;
          e.target.value = val.toString().padStart(2, "0");
          onChange();
        } else if (!isNaN(lastOne) && lastOne >= min && lastOne <= max) {
          val = lastOne;
          e.target.value = val.toString().padStart(2, "0");
          onChange();
        } else if (!isNaN(firstTwo) && firstTwo >= min && firstTwo <= max) {
          val = firstTwo;
          e.target.value = val.toString().padStart(2, "0");
          onChange();
        } else if (!isNaN(firstOne) && firstOne >= min && firstOne <= max) {
          val = firstOne;
          e.target.value = val.toString().padStart(2, "0");
          onChange();
        }
        // If no valid extraction, don't change it - let blur handler fix it
      }
      // For valid numbers within range, don't interfere - let user type freely
    });
    input.addEventListener("blur", e => {
      let inputValue = e.target.value;

      // If empty, set to minimum value
      if (
        inputValue === "" ||
        inputValue === null ||
        inputValue === undefined
      ) {
        e.target.value = min.toString().padStart(2, "0");
        onChange();
        return;
      }

      let val = parseInt(inputValue, 10);

      // If not a valid number, set to minimum value
      if (isNaN(val)) {
        e.target.value = min.toString().padStart(2, "0");
        onChange();
        return;
      }

      // Clamp to valid range
      val = Math.max(min, Math.min(max, val));
      e.target.value = val.toString().padStart(2, "0");
      onChange();
    });
    return input;
  };

  const createTimePicker = () => {
    if (!enableTimeRange) {
      const dom = document.querySelector(`.${className || "dateRangePicker"}`);
      if (dom) {
        const existingTimePicker = dom.querySelector(".timeRangeWrapper");
        if (existingTimePicker) {
          existingTimePicker.remove();
        }
      }
      return;
    }

    const dom = document.querySelector(`.${className || "dateRangePicker"}`);
    if (!dom) return;
    const existingTimePicker = dom.querySelector(".timeRangeWrapper");
    if (existingTimePicker) {
      existingTimePicker.remove();
    }

    if (!document.getElementById("customTimeInputStyles")) {
      const style = document.createElement("style");
      style.id = "customTimeInputStyles";
      style.textContent = `
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none !important;
          appearance: none !important;
          margin: 0 !important;
        }
        #startTimeHours, #startTimeMinutes, #startTimeSeconds,
        #endTimeHours, #endTimeMinutes, #endTimeSeconds {
          -moz-appearance: textfield !important;
        }
      `;
      document.head.appendChild(style);
    }

    const dateDisplayWrapper = dom.querySelector(".rdrDateDisplayWrapper");

    const timeWrapper = document.createElement("div");
    timeWrapper.setAttribute("class", "timeRangeWrapper");
    timeWrapper.style.cssText = `
      padding: 5px 11px;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      gap: 15px;
      align-items: center;
      background: transparent;
    `;

    const startTimeParts = parseTimeString(startTime);
    const endTimeParts = parseTimeString(endTime);

    const startTimeContainer = document.createElement("div");
    startTimeContainer.setAttribute("class", "startTimeContainer");
    startTimeContainer.style.cssText =
      "display: flex; align-items: center; justify-content: center; gap: 2px; flex: 1; width: 150px; border: 1px solid #ddd; border-radius: 4px; background: white; padding: 4px;";

    const updateStartTime = () => {
      const newTime = getCustomTimeValue("start");
      setStartTime(formatTimeString(newTime));
    };

    const startHoursInput = createTimeInputField(
      "startTimeHours",
      startTimeParts.hours.toString().padStart(2, "0"),
      1,
      12,
      updateStartTime
    );
    const startColon1 = document.createElement("span");
    startColon1.textContent = ":";
    startColon1.style.cssText =
      "font-size: 14px; font-weight: 500; color: #333;";
    const startMinutesInput = createTimeInputField(
      "startTimeMinutes",
      startTimeParts.minutes.toString().padStart(2, "0"),
      0,
      59,
      updateStartTime
    );
    const startColon2 = document.createElement("span");
    startColon2.textContent = ":";
    startColon2.style.cssText =
      "font-size: 14px; font-weight: 500; color: #333;";
    const startSecondsInput = createTimeInputField(
      "startTimeSeconds",
      startTimeParts.seconds.toString().padStart(2, "0"),
      0,
      59,
      updateStartTime
    );

    const startAmPmButton = document.createElement("button");
    startAmPmButton.setAttribute("id", "startTimeAmPm");
    startAmPmButton.setAttribute("type", "button");
    startAmPmButton.textContent = startTimeParts.ampm;
    startAmPmButton.style.cssText = `
      padding: 4px 8px;
      border: none;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 600;
      color: #333;
      background: #f0f0f0;
      cursor: pointer;
      font-family: Graphik-Regular;
      min-width: 35px;
    `;
    startAmPmButton.addEventListener("click", () => {
      const current = startAmPmButton.textContent;
      startAmPmButton.textContent = current === "AM" ? "PM" : "AM";
      updateStartTime();
    });

    startTimeContainer.appendChild(startHoursInput);
    startTimeContainer.appendChild(startColon1);
    startTimeContainer.appendChild(startMinutesInput);
    startTimeContainer.appendChild(startColon2);
    startTimeContainer.appendChild(startSecondsInput);
    startTimeContainer.appendChild(startAmPmButton);
    timeWrapper.appendChild(startTimeContainer);

    const endTimeContainer = document.createElement("div");
    endTimeContainer.setAttribute("class", "endTimeContainer");
    endTimeContainer.style.cssText =
      "display: flex; align-items: center; justify-content: center; gap: 2px; flex: 1; width: 150px; border: 1px solid #ddd; border-radius: 4px; background: white; padding: 4px;";

    const updateEndTime = () => {
      const newTime = getCustomTimeValue("end");
      setEndTime(formatTimeString(newTime));
    };

    const endHoursInput = createTimeInputField(
      "endTimeHours",
      endTimeParts.hours.toString().padStart(2, "0"),
      1,
      12,
      updateEndTime
    );
    const endColon1 = document.createElement("span");
    endColon1.textContent = ":";
    endColon1.style.cssText = "font-size: 14px; font-weight: 500; color: #333;";
    const endMinutesInput = createTimeInputField(
      "endTimeMinutes",
      endTimeParts.minutes.toString().padStart(2, "0"),
      0,
      59,
      updateEndTime
    );
    const endColon2 = document.createElement("span");
    endColon2.textContent = ":";
    endColon2.style.cssText = "font-size: 14px; font-weight: 500; color: #333;";
    const endSecondsInput = createTimeInputField(
      "endTimeSeconds",
      endTimeParts.seconds.toString().padStart(2, "0"),
      0,
      59,
      updateEndTime
    );

    const endAmPmButton = document.createElement("button");
    endAmPmButton.setAttribute("id", "endTimeAmPm");
    endAmPmButton.setAttribute("type", "button");
    endAmPmButton.textContent = endTimeParts.ampm;
    endAmPmButton.style.cssText = `
      padding: 4px 8px;
      border: none;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 600;
      color: #333;
      background: #f0f0f0;
      cursor: pointer;
      font-family: Graphik-Regular;
      min-width: 35px;
    `;
    endAmPmButton.addEventListener("click", () => {
      const current = endAmPmButton.textContent;
      endAmPmButton.textContent = current === "AM" ? "PM" : "AM";
      updateEndTime();
    });

    endTimeContainer.appendChild(endHoursInput);
    endTimeContainer.appendChild(endColon1);
    endTimeContainer.appendChild(endMinutesInput);
    endTimeContainer.appendChild(endColon2);
    endTimeContainer.appendChild(endSecondsInput);
    endTimeContainer.appendChild(endAmPmButton);
    timeWrapper.appendChild(endTimeContainer);

    if (dateDisplayWrapper) {
      if (dateDisplayWrapper.firstChild) {
        dateDisplayWrapper.insertBefore(
          timeWrapper,
          dateDisplayWrapper.firstChild.nextSibling
        );
      } else {
        dateDisplayWrapper.appendChild(timeWrapper);
      }
    } else {
      const calendarWrapper = dom.querySelector(".rdrCalendarWrapper") || dom;
      calendarWrapper.insertBefore(timeWrapper, calendarWrapper.firstChild);
    }
  };

  const updateTimeInputs = () => {
    if (!enableTimeRange) return;
    const startTimeParts = parseTimeString(startTime);
    const endTimeParts = parseTimeString(endTime);

    const startHoursInput = document.getElementById("startTimeHours");
    const startMinutesInput = document.getElementById("startTimeMinutes");
    const startSecondsInput = document.getElementById("startTimeSeconds");
    const startAmPmButton = document.getElementById("startTimeAmPm");
    if (
      startHoursInput &&
      startMinutesInput &&
      startSecondsInput &&
      startAmPmButton
    ) {
      startHoursInput.value = startTimeParts.hours.toString().padStart(2, "0");
      startMinutesInput.value = startTimeParts.minutes
        .toString()
        .padStart(2, "0");
      startSecondsInput.value = startTimeParts.seconds
        .toString()
        .padStart(2, "0");
      startAmPmButton.textContent = startTimeParts.ampm;
    }

    const endHoursInput = document.getElementById("endTimeHours");
    const endMinutesInput = document.getElementById("endTimeMinutes");
    const endSecondsInput = document.getElementById("endTimeSeconds");
    const endAmPmButton = document.getElementById("endTimeAmPm");
    if (endHoursInput && endMinutesInput && endSecondsInput && endAmPmButton) {
      endHoursInput.value = endTimeParts.hours.toString().padStart(2, "0");
      endMinutesInput.value = endTimeParts.minutes.toString().padStart(2, "0");
      endSecondsInput.value = endTimeParts.seconds.toString().padStart(2, "0");
      endAmPmButton.textContent = endTimeParts.ampm;
    }
  };

  useEffect(() => {
    createApplyButton();
    const timer = setTimeout(() => {
      createTimePicker();
      updateTimeInputs();
    }, 100);
    return () => clearTimeout(timer);
  }, [enableTimeRange, customDateObj]);

  useEffect(() => {
    if (enableTimeRange && customDateObj) {
      if (customDateObj.startDate) {
        const currentDatePart = getDatePartOnly(customDateObj.startDate);
        const prevDatePart = prevStartDateRef.current;
        const dateChanged =
          prevDatePart !== null && currentDatePart !== prevDatePart;
        const isInitializing = prevDatePart === null;

        const time = convertDateTo24TimeString(customDateObj.startDate);

        if (time !== "00:00:00") {
          setStartTime(time);
          prevStartDateRef.current = currentDatePart;
        } else if (
          isInitializing ||
          (dateChanged && startTime === "00:00:00")
        ) {
          setStartTime(time);
          prevStartDateRef.current = currentDatePart;
        } else if (dateChanged) {
          prevStartDateRef.current = currentDatePart;
        }
      } else {
        prevStartDateRef.current = null;
      }

      if (customDateObj.endDate) {
        const currentDatePart = getDatePartOnly(customDateObj.endDate);
        const prevDatePart = prevEndDateRef.current;
        const dateChanged =
          prevDatePart !== null && currentDatePart !== prevDatePart;
        const isInitializing = prevDatePart === null;

        const time = convertDateTo24TimeString(customDateObj.endDate);
        const isDefaultTime = time === "23:59:59" || time === "00:00:00";
        const isCurrentDefault =
          endTime === "23:59:59" || endTime === "00:00:00";

        if (!isDefaultTime) {
          setEndTime(time);
          prevEndDateRef.current = currentDatePart;
        } else if (isInitializing || (dateChanged && isCurrentDefault)) {
          setEndTime(time === "00:00:00" ? "23:59:59" : time);
          prevEndDateRef.current = currentDatePart;
        } else if (dateChanged) {
          prevEndDateRef.current = currentDatePart;
        }
      } else {
        prevEndDateRef.current = null;
      }
    }
  }, [customDateObj?.startDate, customDateObj?.endDate, enableTimeRange]);

  useEffect(() => {
    if (enableTimeRange) {
      updateTimeInputs();
    }
  }, [startTime, endTime, enableTimeRange]);

  useEffect(() => {
    const timer = setTimeout(() => {
      createTimePicker();
    }, 100);
    return () => clearTimeout(timer);
  }, [customDate, enableTimeRange]);

  return (
    <DateRange
      className={className}
      editableDateInputs={false}
      onChange={handleChange}
      moveRangeOnFirstSelection={false}
      ranges={customDate}
      minDate={new Date(REPORT_DATE_FILTER_MIN_DATE)}
      maxDate={new Date()}
    />
  );
};

export default DateRangePicker;
export { DateRangePicker };
